/* eslint-disable no-unneeded-ternary */
import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const editVendorQuery = (data) => {
  const { address, vendorName, company, expense, shortCloseApprovalRequired, numberOfLevels,
    level1Approver,
    level1ApproverEmail,
    level2Approver,
    level2ApproverEmail } = data || {};
  const vendorExpenseItemMapping = expense;
  const shortCloseApprovalValue = shortCloseApprovalRequired === 'yes' ? true : false;
  const approvers = [];
  let hasVendorApprover = false;
  const trimmedLevel1Email = level1ApproverEmail ? level1ApproverEmail.trim() : '';
  const trimmedLevel2Email = level2ApproverEmail ? level2ApproverEmail.trim() : '';

  if (shortCloseApprovalValue && numberOfLevels >= 1) {
    if (level1Approver === 'vendor') {
      hasVendorApprover = true;
    }
    approvers.push({
      roleIdentifier: level1Approver,
      approverType: level1Approver === 'vendor' ? 1 : 2,
      emailOfVendor: level1Approver === 'vendor' ? trimmedLevel1Email : '',
      level: 1,
      users: []
    });

    if (numberOfLevels === 2 && level2Approver) {
      if (level2Approver === 'vendor') {
        hasVendorApprover = true;
      }
      approvers.push({
        roleIdentifier: level2Approver,
        approverType: level2Approver === 'vendor' ? 1 : 2,
        emailOfVendor: level2Approver === 'vendor' ? trimmedLevel2Email : '',
        level: 2,
        users: []
      });
    }
  }

  const req = {
    vendorID: vendorName,
    address,
    vendorExpenseItemMapping,
    companyIDList: company?.map((i) => i.id),
    isCreated: true,
    shortCloseApprovalRequired: shortCloseApprovalValue,
    numberOfLevels: numberOfLevels ? parseInt(numberOfLevels, 10) : 0,
    vendorDashboardAccessRequired: hasVendorApprover
      ? true
      : false,
    approvers
  };
  return axios.post(apiurl?.editVendor, req);
};

const editVendor = () => {
  return useMutation(['editVendor'], editVendorQuery);
};

export default editVendor;
